import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';

function ListTabungan() {

  //Roles
  const USP = 3;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [dataTabungan, setDataTabungan] = useState([]);

  // CONTROLLER & LOAD DATA
  const fetchDataTabungan = async () => {

    await baseAPI
      .get(`/v1/ajuantabung`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.datatabung
        setDataTabungan(data)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  const deleteTabungan = async (id) => {
  Swal.fire({
    title: 'Apakah anda akan menghapus ajuan tabungan?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then(async (result) => {
    if (result.isConfirmed) {
      setIsLoading(true);
      await baseAPI
        .delete(`/v1/ajuantabung/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          Swal.fire({
            icon: 'success',
            title: 'Ajuan tabungan berjangka has been deleted',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .catch((error) => {
          setIsLoading(false);
          Swal.fire({
            icon: 'error',
            title: 'Delete data is failed',
            showConfirmButton: false,
            timer: 1500
          })
          console.log(`error ${error}`)
        })
        .finally(() => {
          fetchDataTabungan();
          setIsLoading(false);
        });
    }
  });
  }

  useEffect(() => {
    setIsLoading(true);
    if (users.role === USP) {
      fetchDataTabungan();
    }
  }, [token]);

  const contentTableAction = (id, iduser, status, setoranke) => {
    if (id !== null) {
      return (
        <div className='text-center'>
          <Link 
            to={`/datatabungan/listtabungan/edittabungan/${id}/${iduser}`} 
            className="badge badge-primary"
            style={{ backgroundColor: "#6A9C89", marginRight: 10 }}
          >
            <Icon name="Edit" size={16} />
          </Link>
          <button 
            hidden={status !== "Disetujui" && setoranke == 0 ? false : true}
            className="badge bg-danger"
            onClick={() => deleteTabungan(id)}
          >
            <Icon name="Trash" size={16} />
          </button>
        </div>
      )
    }
  };
  
  const tabungListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'NPP',
        id: 'npp',
        width: '8%',
        accessor: 'npp',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.npp_anggota}</div>
      },
      {
        Header: 'Nama',
        id: 'nama',
        width: '12%',
        accessor: 'nama',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.name_anggota}</div>
      },
      {
        Header: 'Nomor Tabungan',
        id: 'notabung',
        width: '8%',
        accessor: 'notabung',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.notrxdetailtabung}</div>
      },
      {
        Header: 'Jangka',
        id: 'jangka',
        width: '8%',
        accessor: 'jangka',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.jangka}</div>
      },
      {
        Header: 'Setoran',
        id: 'setoran',
        width: '8%',
        accessor: 'setoran',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseInt(cellInfo.row.original.setoran).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Total',
        id: 'total',
        width: '8%',
        accessor: 'total',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseFloat(cellInfo.row.original.total).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Tanggal Tempo',
        id: 'tgltempo',
        width: '8%',
        accessor: 'tgltempo',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{moment(cellInfo.row.original.tgl_tempo).format("DD/MM/YYYY")}</div>
      },
      {
        Header: 'Status',
        id: 'status',
        width: '8%',
        accessor: 'status',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.status}</div>
      },
      {
        Header: 'Action',
        id: 'action',
        width: '8%',
        Cell: (cellInfo) =>
          contentTableAction(
            cellInfo.row.original.id,
            cellInfo.row.original.id_users,
            cellInfo.row.original.status,
            cellInfo.row.original.setoran_ke
          )
      }
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Data Tabungan"
                columns={columns}
                data={dataTabungan}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Data Tabungan</Link> /{' '}
                <Link to='/datatabungan/listtabungan' style={{ color: '#333' }}>List Tabungan</Link>
              </li>
            </ol>
          </div>

          {/* Download Report Data */}
          {/* <div className='col-auto ml-auto d-print-none'>
            <Link to="/employee/reportemployee">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('download report data')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Download" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Download Pengajuan Tabungan</span>
                </div>
              </button>
            </Link>
          </div> */}

        </div>
      </div>
    </>
  )

  const handleView = () => {
    switch (users.role) {
      case USP:
        return tabungListView();
    }
  };

  const mainView = () =>  (
    <>
      {handleView()}
    </>
  )
    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      {isLoading ? <LoadingView /> : mainView()}

    </div>

  );

}

export default ListTabungan;